import type { ReactNode } from "react";
import { Header } from "../shared/Header";
import { Footer } from "../shared/Footer";

export interface LegalSection {
  title: string;
  body: ReactNode;
}

interface LegalLayoutProps {
  testId: string;
  eyebrow: string;
  title: string;
  updatedAt: string;
  sections: LegalSection[];
  highlight?: ReactNode;
}

export function LegalLayout({ testId, eyebrow, title, updatedAt, sections, highlight }: LegalLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main data-testid={testId} className="flex-1">
        <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-24">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-emerald-500">{eyebrow}</p>
          <h1 className="mt-3 text-4xl font-semibold tracking-tight text-slate-100 sm:text-5xl">{title}</h1>
          <p className="mt-4 font-mono text-xs text-slate-500">Última atualização: {updatedAt}</p>
          {highlight}
          <div className="mt-12 space-y-10">
            {sections.map((s, i) => (
              <section key={s.title} data-testid={`${testId}-section-${i + 1}`} className="border-t border-slate-800 pt-8">
                <h2 className="text-base font-semibold text-slate-100 md:text-lg">
                  <span className="mr-2 font-mono text-emerald-500">{String(i + 1).padStart(2, "0")}</span>
                  {s.title}
                </h2>
                <div className="mt-3 space-y-3 text-sm leading-relaxed text-slate-300 sm:text-base">{s.body}</div>
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
